import {Component, HostListener, Inject, inject, model, ModelSignal, signal} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';
import { ClrIconModule } from '@clr/angular';
import { AuthenticationService } from '../security/authentication.service';
import { HasPermissionDirective } from '../security/has-permission.directive';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, ClrIconModule, RouterLink, HasPermissionDirective],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'KIUT Portal';
  stage = environment.stage;
  valueSignal = signal<any>(null);

  // Off-canvas nav state (Clarity hamburger, active <=992px).
  navOpen = signal(false);

  authService: AuthenticationService = inject(AuthenticationService);

  toggleNav() {
    this.navOpen.update(open => !open);
  }

  closeNav() {
    this.navOpen.set(false);
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeNav();
  }

  public login() {
    this.authService.login();

  }

  public logout() {
    this.authService.logout();
  }
}
